export default __webpack_public_path__ + "static/12-6ef2f8a46d61f5d5c1fe5cc6b9953def.webp";